import React from 'react';
import { Box, Flex, Text } from 'core/components';

export default function TracerouteText({ traceData = [] }) {
  return (
    <Flex overflow="auto">
      {traceData.map(({ trace, target_ip, timestamp }, i) => {
        const key = `${target_ip}_${i}`;
        return (
          <Box key={key} flex="1 0 auto" mr={1} mt={1}>
            <Text as="div" fontSize={12} monospace>
              <Box>{timestamp}</Box>
              <Box>traceroute to {target_ip}</Box>
              {trace.map(({ ttl, timeouts, hops }) => (
                <Flex key={`trace_${ttl}`}>
                  <Box flex={`0 0 ${String(hops.length).length}ch`} mr="2ch" textAlign="right">
                    {ttl}
                  </Box>
                  <Box pr={1}>
                    <div>{Array(timeouts).fill('*').join(' ')}</div>
                    {hops.map(({ ip, latency }) => (
                      <div key={`${ttl}_${ip}_${latency}`}>
                        {ip}
                        <Text ml="2ch">{(latency / 1000).toFixed(3)}ms</Text>
                      </div>
                    ))}
                  </Box>
                </Flex>
              ))}
            </Text>
          </Box>
        );
      })}
    </Flex>
  );
}
